module.exports = __webpack_public_path__ + "static/media/Happy3.1acbf8b1.svg";